// extracted by mini-css-extract-plugin
export default {"companyContainer":"gP-z","companyImage":"hP-z","container":"iP-z","heading":"jP-z","darkText":"kP-z","smallHeading":"lP-z","darkBackground":"mP-z","whiteBackground":"nP-z"};